/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- SENTIMENT - CONFIGURATION PAGE : STYLES --------------- ++++++++++ */
export default {
    sentimentconfig: {
    }
};
